import { render, staticRenderFns } from "./bindphone.vue?vue&type=template&id=453506f8&scoped=true"
import script from "./bindphone.vue?vue&type=script&lang=js"
export * from "./bindphone.vue?vue&type=script&lang=js"
import style0 from "./bindphone.vue?vue&type=style&index=0&id=453506f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453506f8",
  null
  
)

export default component.exports